import React, { useState, useEffect } from "react";
import ProfileInfoSkeleton from "./ProfileInfoSkeleton";
import PasswordChangeModal from "./PasswordChangeModal";
import { fetchUserData } from "../../utilities/UserProfileUtilities";
function ProfileDetails() {
  const [userProfile, setUserProfile] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    organization: "",
  });

  const [editable, setEditable] = useState(false);
  const [isProfileInfoCollapsed, setIsProfileInfoCollapsed] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const handlePasswordModalClose = () => setShowPasswordModal(false);
  const handlePasswordModalShow = () => setShowPasswordModal(true);
  const toggleProfileInfo = () => {
    setIsProfileInfoCollapsed(!isProfileInfoCollapsed);
    setEditable(false);
  };

  useEffect(() => {
    fetchUserData(setLoading, setUserProfile);
  }, []);

  const saveProfile = () => {
    setLoading(true);
    // TODO : Add save profile functionality
    console.log("Save profile functionality here.");
    setLoading(false);
    setEditable(false);
  };

  // Function to handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if(value ===''){
      setUserProfile({ ...userProfile, [name]: "" });
    }
    else{

      setUserProfile({ ...userProfile, [name]: value });
    }
    console.log(userProfile,name,value);
  };

  return (
    <>
      <div className="container mt-5">
        {loading ? (
          <ProfileInfoSkeleton />
        ) : (
          <div className="card shadow ">
            <div className="card-header  card-header d-flex justify-content-between align-items-center ">
              <div>
                <h3 onClick={toggleProfileInfo} style={{ cursor: "pointer" }}>
                  Profile Info
                </h3>
              </div>
              <div>
                {!isProfileInfoCollapsed && (
                  <i
                    className="fas fa-edit p-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => setEditable(!editable)}
                  ></i>
                )}
                <i
                  className={`fas ${
                    isProfileInfoCollapsed ? "fa-angle-down" : "fa-angle-up"
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={toggleProfileInfo}
                ></i>
              </div>
            </div>
            <div className={isProfileInfoCollapsed ? "collapse" : ""}>
              <div className="card-body p-4">
                <div className="mb-3 form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="first_name"
                    value={userProfile.first_name !=null ? userProfile.first_name  : "N.A."}
                    onChange={handleInputChange}
                    disabled={!editable}
                  />
                  <label className="form-label">
                    <i className="fas fa-user me-2 fa-fw" />
                    First Name
                  </label>
                </div>
                <div className=" mb-3 form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="last_name"
                    value={userProfile.last_name  !=null ? userProfile.last_name  : "N.A."}
                    onChange={handleInputChange}
                    disabled={!editable}
                  />
                  <label className="form-label">
                    <i className="fas fa-user  me-2 fa-fw" />
                    Last Name
                  </label>
                </div>
                <div className="mb-3 form-floating">
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={userProfile.email !=null ? userProfile.email  : "N.A."}
                    onChange={handleInputChange}
                    disabled={true}
                  />
                  <label className="form-label">
                    <i className="fas fa-envelope  me-2 fa-fw" />
                    Email Address
                  </label>
                </div>
                <div className="mb-3 form-floating">
                  <input
                    type="tel"
                    className="form-control"
                    name="phone_number"
                    value={userProfile.phone_number !=null ? userProfile.phone_number  : "N.A."}
                    onChange={handleInputChange}
                    disabled={!editable}
                  />
                  <label className="form-label">
                    <i className="fa-solid fa-phone me-2" />
                    Phone Number
                  </label>
                </div>
                <div className="mb-3 form-floating">
                  <input
                    type="tel"
                    className="form-control"
                    name="secondary_contacts"
                    value={userProfile.secondary_contacts !=null ? userProfile.secondary_contacts  : "N.A."}
                    onChange={handleInputChange}
                    disabled={!editable}
                  />
                  <label className="form-label">
                    <i className="fa-solid fa-address-book me-2" />
                    Secondary Contact
                  </label>
                </div>
                <div className="mb-3 form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="organization"
                    value={userProfile.organization !=null ? userProfile.organization  : "N.A."}
                    onChange={handleInputChange}
                    disabled={true}
                  />
                  <label className="form-label">
                    <i className="fa-solid fa-sitemap me-2" />
                    Organization
                  </label>
                </div>
                <div className="mb-3 form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="role"
                    value={userProfile.role || "NA"}
                    onChange={handleInputChange}
                    disabled={true}
                  />
                  <label className="form-label">
                    <i className="fa-solid fa-sitemap me-2" />
                    Role
                  </label>
                </div>
                <div className="  d-flex w-100 justify-content-between">
                  <div className="p-2 justify-content-start">
                    <button
                      onClick={handlePasswordModalShow}
                      className="btn btn-primary "
                    >
                      Change Password
                    </button>
                  </div>
                  <div className="p-2   ">
                    {editable && (
                      <>
                        <button
                          onClick={saveProfile}
                          className="btn btn-success "
                        >
                          Save
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <PasswordChangeModal
        show={showPasswordModal}
        handleClose={handlePasswordModalClose}
      />
    </>
  );
}

export default ProfileDetails;
